class UpsellButton extends HTMLElement {
  constructor() {
    super();
    this.variantId = '49055525830993'; // Spezifische Produktvariant-ID
    this.translations = window.upsellbuttontranslations; // Übersetzungen aus window.translations laden
    this.initialize();
  }

  initialize() {
    this.button = this.querySelector('.upsell-salt__button');
    this.buttonText = this.querySelector('.upsell-salt__button-text');
    this.checkmark = this.querySelector('.upsell-salt__checkmark');
    this.messageElement = this.querySelector('#upsell-message');

    if (!this.button) return;

    this.button.addEventListener('click', this.handleClick.bind(this));

    // Animation beim Hover
    this.button.addEventListener('mouseover', () => {
      this.buttonText.style.transition = 'transform 0.5s ease-in-out';
      this.buttonText.style.transform = 'rotate(360deg)';
    });

    this.button.addEventListener('mouseout', () => {
      this.buttonText.style.transform = 'rotate(0deg)';
    });

    this.updateUpsell();
  }

  updateUpsell() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        if (cart.items.length === 0) {
          // Warenkorb ist leer, Upsell ausblenden
          this.style.display = 'none';
          return;
        } else {
          // Warenkorb ist nicht leer, Upsell anzeigen
          this.style.display = 'flex';
        }

        let productInCart = cart.items.find(item => item.variant_id == this.variantId);
        const quantityInCart = productInCart ? productInCart.quantity : 0;

        this.updateMessage(quantityInCart);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  updateMessage(quantityInCart) {
    const discounts = [
      { threshold: 3, discount: 11 },
      { threshold: 6, discount: 16 },
      { threshold: 12, discount: 21 }
    ];

    let message = '';
    let additionalToAdd = 0;

    if (quantityInCart >= 12) {
      // Maximale Menge erreicht, Upsell ausblenden
      this.style.display = 'none';
      return;
    }

    for (let i = 0; i < discounts.length; i++) {
      if (quantityInCart < discounts[i].threshold) {
        const nextDiscount = discounts[i];
        additionalToAdd = nextDiscount.threshold - quantityInCart;
        message = `${this.translations.add_more_to_save} ${additionalToAdd} ${this.translations.more_to_save} ${nextDiscount.discount}%`;
        break;
      }
    }

    if (quantityInCart === 0) {
      message = `${this.translations.add_three_x_save}`;
      additionalToAdd = 3;
    }

    this.messageElement.textContent = message;
    this.additionalToAdd = additionalToAdd;
  }

  handleClick() {
    this.addProductToCart(this.additionalToAdd);

    // Zeige das Häkchen und blende den Text aus
    this.buttonText.style.display = 'none';
    this.checkmark.style.display = 'inline-block';

    // Nach kurzer Zeit den Button wieder zurücksetzen
    setTimeout(() => {
      this.buttonText.style.display = 'inline-block';
      this.checkmark.style.display = 'none';
    }, 2000);
  }

  addProductToCart(quantity) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          quantity: quantity,
          id: this.variantId
        }]
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log('Produkt hinzugefügt:', data);
      this.updateCart();
    })
    .catch(error => {
      console.error('Fehler beim Hinzufügen des Produkts:', error);
    });
  }

  updateCart() {
    // Warenkorb aktualisieren
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartItemsElements = document.querySelectorAll('cart-items, cart-drawer-items');
        cartItemsElements.forEach(element => {
          if (typeof element.onCartUpdate === 'function') {
            element.onCartUpdate();
          }
        });

        // Upsell aktualisieren
        this.updateUpsell();

        // UpsellButton-Instanzen neu initialisieren
        UpsellButton.initAll();
      })
      .catch(error => {
        console.error('Fehler beim Aktualisieren des Warenkorbs:', error);
      });
  }

  static initAll() {
    document.querySelectorAll('upsell-button').forEach((element) => {
      if (!element.hasAttribute('data-initialized')) {
        element.setAttribute('data-initialized', 'true');
        Object.setPrototypeOf(element, UpsellButton.prototype);
        element.initialize();
      }
    });
  }
}

customElements.define('upsell-button', UpsellButton);

// Beim Laden der Seite UpsellButton initialisieren
document.addEventListener('DOMContentLoaded', () => {
  UpsellButton.initAll();
});

// UpsellButton im globalen Scope verfügbar machen
window.UpsellButton = UpsellButton;

